// extracted by mini-css-extract-plugin
export var active = "_bw-7";
export var container = "_bw-0";
export var evenWidth = "_bw-4";
export var large = "_bw-5";
export var outlet = "_bw-8";
export var slide = "_bw-2";
export var small = "_bw-6";
export var tab = "_bw-3";
export var tabs = "_bw-1";